import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Shipstation from "../../medias/shipstation.png";
import Veeqo from "../../medias/veeqo.png";
import { motion } from 'framer-motion';
import {ShipStationFeaturesCard, VeeqoFeaturesCard} from "./AllFeaturesCard";

const Features = () => {
  const [searchParams] = useSearchParams();
  const platformParam = searchParams.get("platform");
  const [show, setShow] = useState(platformParam !== "veeqo");
  
  // Update state if query param changes
  useEffect(() => {
    if (platformParam === "veeqo") {
      setShow(false);
    } else if (platformParam === "shipstation") {
      setShow(true);
    }
  }, [platformParam]);
  return (
    <div className="mx-auto max-w-[1120px]  px-[24px] sm:px-0 pt-[100px] mb-[150px]" id="features">
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true, amount: 0.2 }}
      >
        <p className="sm:text-[48px] text-[42px] text-center">
          The <span className="text-[#1387f2]">features</span> you need:
        </p>
      </motion.div>
      <div className="flex max-w-[624px] mx-auto bg-[#EDEDED] p-[12px] rounded-[32px] mb-[35px] mt-[40px]">
        <div
          className={`cursor-pointer max-w-[300px] w-full flex items-center justify-center rounded-[16px] p-[22px] animated-bg ${show ? "bg-white" : "bg-[#EDEDED]"}`}
          onClick={() => setShow(true)}
        >
          <img src={Shipstation} alt="Shipstation logo" />
        </div>
        <div
          className={`cursor-pointer max-w-[300px] w-full flex items-center justify-center rounded-[16px] p-[24px] animated-bg ${!show ? "bg-white" : "bg-[#EDEDED]"}`}
          onClick={() => setShow(false)}
        >
          <img src={Veeqo} alt="Veeqo logo" />
        </div>
      </div>

      <motion.div
        key={show}
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, x: 100 }}
        transition={{ duration: 0.5 }}
      >
        {show ? <ShipStationFeaturesCard /> : <VeeqoFeaturesCard />}
      </motion.div>
    </div >
  );
};

export default Features;
